export default __webpack_public_path__ + "static/media/portfeille.a4ba884e.svg";